export default function CTA() {
  return (
    <section className="py-20 px-4 bg-gradient-to-br from-amber-500 to-amber-600">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
          레이저 가공 견적 문의
        </h2>
        <p className="text-xl text-slate-800 mb-10">
          정밀한 레이저 커팅과 마킹 서비스를 경험하세요
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href="tel:02-2261-2017"
            className="inline-flex items-center justify-center gap-2 px-10 py-5 bg-slate-900 text-white text-lg font-bold rounded-lg hover:bg-slate-800 transition-colors whitespace-nowrap cursor-pointer shadow-xl"
          >
            <i className="ri-phone-fill text-2xl"></i>
            전화 상담 02-2261-2017
          </a>
          <a
            href="mailto:nt2017@daum.net"
            className="inline-flex items-center justify-center gap-2 px-10 py-5 bg-white text-slate-900 text-lg font-bold rounded-lg hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer shadow-xl"
          >
            <i className="ri-mail-fill text-2xl"></i>
            이메일 문의
          </a>
        </div>
      </div>
    </section>
  );
}
